import {useCallback} from "react";
import {useDispatch} from "react-redux";
import * as actions from "../../actions/actions";

export const useMessageTemplatesAction = (exhibitionId) => {
    const dispatch = useDispatch()

    const getMessageTemplate = useCallback((typeId) => {
        dispatch(actions.getMessageTemplate({
            exhibitionId: exhibitionId,
            typeId: typeId
        }))
    }, [dispatch, exhibitionId])

    const getMessageTemplateTypes = useCallback((exhibitionId, isCoorganization) => {
        dispatch(actions.getMessageTemplateTypes({
            ...(exhibitionId && {ExhibitionId: exhibitionId}),
            ...(isCoorganization && {isCoorg: isCoorganization ? '1' : '0'}),
        }))
    }, [dispatch])

    const getMessageTemplateTypeVariables = useCallback((typeId) => {
        dispatch(actions.getMessageTemplateTypeVariables({
            typeId: typeId
        }))
    }, [dispatch])

    const updateMessageTemplate = useCallback((values, typeId) => {
        dispatch(actions.updateMessageTemplate({
            exhibitionId: exhibitionId,
            typeId: typeId,
            TitleEN: values.title?.en,
            TitleEL: values.title?.el,
            BodyEN: values.body?.en,
            BodyEL: values.body?.el,
            isActive: values.isActive
        }))
    }, [dispatch, exhibitionId])
    
    const setMessageToUser = useCallback((message) => {
        dispatch(actions.setMessageToUser(message))
    }, [dispatch])
    
    const setMessageTemplateTypeId = useCallback((id) => {
        dispatch(actions.setMessageTemplateTypeId(id))
    }, [dispatch])
    
    
    return {
        getMessageTemplate,
        getMessageTemplateTypes,
        getMessageTemplateTypeVariables,
        updateMessageTemplate,
        setMessageToUser,
        setMessageTemplateTypeId
    }
}